var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "1em",
    height: "1em",
    viewBox: "0 -48 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.045-8.091c-8.792-8.792-8.792-23.065-.001-31.857 8.791-8.792 23.062-8.792 31.854 0 8.792 8.792 8.792 23.065.001 31.857-8.791 8.792-23.062 8.792-31.854 0zM37.07-10.92c7.229-7.23 7.229-18.969-.001-26.199s-18.967-7.23-26.196 0c-7.229 7.23-7.229 18.969.001 26.199s18.967 7.23 26.196 0zM17.421-8.212v-.844c1.046 0 1.75-.101 2.109-.305.359-.202.645-.538.855-1.007.212-.469.317-1.367.316-2.695v-8.274c.001-2.328-.07-3.836-.21-4.524-.11-.499-.281-.847-.516-1.042-.234-.196-.554-.293-.961-.294-.437.001-.969.118-1.593.352l-.329-.844 9.469-2.625h1.031v17.251c0 1.343.098 2.238.293 2.683.196.445.484.777.868.996.382.219 1.082.328 2.097.328v.844H17.421zm3.358-25.352a4.201 4.201 0 01.465-5.918 4.201 4.201 0 015.918.465 4.201 4.201 0 01-.465 5.918 4.201 4.201 0 01-5.918-.465z",
    fill: "#000",
    stroke: "none"
  })));
}

export default SvgInfo1;